<template>
  <div>
    <div class="mainImage">
      <h1 class="title">RESIDENTIAL</h1>
    </div>
    <p class="servicesTitle">Services Provided</p>
    <div class="services">
      <p class="contentOne">
        Intext Electric handles all aspects of residential contracting in South
        Alberta. From the installation of new light fixtures to wiring a new
        home. Examples of our typical services include:
      </p>
      <table>
        <tr>
          <td>Code upgrades and corrections</td>
          <td>New construction</td>
        </tr>
        <tr>
          <td>Custom homes</td>
          <td>Panel upgrades</td>
        </tr>
        <tr>
          <td>Service upgrades</td>
          <td>Troubleshooting and repairs</td>
        </tr>
        <tr>
          <td>Hot tubs</td>
          <td>Patio heaters</td>
        </tr>
        <tr>
          <td>Recessed lighting</td>
          <td>Home automation</td>
        </tr>
        <tr>
          <td>Backup generators</td>
          <td>Electric heat</td>
        </tr>
        <tr>
          <td>Knob and tube removal</td>
          <td>Restoration install</td>
        </tr>
        <tr>
          <td>Fire restoration</td>
          <td>Flood restoration</td>
        </tr>
        <tr>
          <td>Outlets, plugs</td>
          <td>Light fixtures</td>
        </tr>
        <tr>
          <td>Dimmer switches</td>
          <td>Sub panels</td>
        </tr>
        <tr>
          <td>Heat pumps and air conditioners</td>
          <td>Electric vehicle charges</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
table {
  width: 70%;
  margin-top: 50px;
  font-size: 25px;
  text-align: center;
  border-collapse: collapse;
  margin-left: 15%;
  tr:nth-child(odd) {
    background-color: #e9e9e9;
  }
  td {
    padding: 5px;
  }
}
.mainImage {
  background-image: url("../assets/residential.jpeg");
  background-position: center -110px;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 650px;
  .title {
    font-family: "Old Standard TT";
    font-size: 70px;
    letter-spacing: 5px;
    text-align: center;
    padding-top: 100px;
    color: white;
    font-weight: 100;
  }
}
.servicesTitle {
  text-align: center;
  font-size: 40px;
  margin-top: 50px;
}
.services {
  height: 700px;
}
.contentOne {
  text-align: center;
  margin-top: 80px;
  width: 60%;
  margin-left: 20%;
  font-size: 25px;
}
@media only screen and (max-width: 900px) {
  .mainImage {
    .title {
      font-size: 40px;
    }
  }
  .services {
    height: 500px;
  }
  .contentOne {
    width: 80%;
    margin-left: 10%;
    font-size: 22px;
  }
}
@media only screen and (max-width: 500px) {
  .services {
    height: 700px;
  }
}
</style>
